/**
 * 📨 Postacı — Merkezi İletişim Sözlüğü
 * Kullanıcıya gösterilecek tüm (Success, Info, Error, Warning) başlık ve mesajları buradan yönetilir.
 */

export const TOAST_TITLES = {
  SUCCESS: 'İşlem Tamam',
  ERROR: 'Kısa Bir Kesinti',
  WARNING: 'Küçük Bir Uyarı',
  INFO: 'Bilgilendirme',
  DOWNLOADED: 'Cihaza İndirildi',
  DOWNLOADING: 'İndiriliyor',
  DELETED: 'Silindi',
  GROUP_DELETED: 'Grup Silindi',
  CONNECTION_ERROR: 'Bağlantı Kurulamadı',
  UNAUTHORIZED: 'Erişim Sağlanamadı',
  UPDATED: 'Güncelleme Tamamlandı',
  INVITE_CLOSED: 'Davetiyeler Kapatıldı',
  LEFT_GROUP: 'Gruptan Ayrıldınız',
  LIMIT_EXCEEDED: 'Limit Aşıldı',
  INSUFFICIENT_MEMBERS: 'Yetersiz Katılımcı',
  INVITE_SENT: 'Davet Gönderildi',
  INVITE_FAILED: 'Davet Gönderilemedi',
  UNSUPPORTED: 'Desteklenmiyor',
  TOKEN_FAILED: 'Token Kaydedilemedi',
  TOKEN_NOT_RECEIVED: 'Token Alınamadı',
  PERMISSION_DENIED: 'İzin Engellendi',
  OPERATION_CANCELLED: 'İşlem İptal',
  REQ_FAILED: 'İşlem Başarısız',
  REMINDER: 'Davet Hatırlatması',
  NOTIF_ACTIVE: 'Bildirimler Aktif',
  CONNECTION_RESTORED: 'Bağlantı Yenilendi',
  COPIED: 'Kopyalandı',
}

export const TOAST_MESSAGES = {
  NETWORK_ERROR: 'Ufak bir bağlantı sorunu var. Lütfen internet bağlantınızı kontrol edip tekrar dener misin?',
  UNKNOWN_ERROR: 'Şu an işlemine devam edemiyoruz. Lütfen daha sonra tekrar dene.',
  VALIDATION_ERROR: 'Grup adını boş bırakamayız, ona harika bir isim bulmalısın.',
  GROUP_NAME_EMPTY: 'Grup adını boş bırakamayız, ona harika bir isim bulmalısın.',
  GROUP_NAME_UPDATED: 'Grubunun yeni adı başarıyla kaydedildi.',
  LIMIT_REACHED: (max: number) => `Bu limiti aştık (Bu süre en fazla ${max} kez uzatılabilir).`,
  MAX_EXTENSIONS_REACHED: (max: number) => `Davet süresi en fazla ${max} kez uzatılabilir.`,
  DATE_PAST_ERROR: 'Geçmişe yolculuk yapamıyoruz. Lütfen gelecekte bir tarih seç.',
  PAST_DATE_ERROR: 'Geçmiş bir tarih/saat seçilemez.',
  DATE_START_ERROR: 'Son katılım tarihi, gün başlangıcından önce olmalıdır.',
  DEADLINE_BEFORE_LOTTERY: 'Son katılım tarihi, gün başlangıcından önce olmalı.',
  DATE_ORDER_ERROR: 'Gün başlangıç tarihi, son katılım tarihinden sonra bir gün olmalıdır.',
  LOTTERY_AFTER_DEADLINE: 'Gün başlangıcı, son katılım tarihinden sonra olmalı.',
  DATE_UPDATED: 'Tarihler başarıyla ayarlandı ve takvime işlendi.',
  DEADLINE_UPDATED: (dateStr: string) => `Son katılım ${dateStr} olarak güncellendi.`,
  LOTTERY_UPDATED: (dateStr: string) => `Gün başlangıcı ${dateStr} olarak güncellendi.`,
  PWA_NOT_SUPPORTED: 'Cihazın şu an için anlık bildirimleri tam olarak desteklemiyor.',
  NOTIFS_NOT_SUPPORTED: 'Tarayıcınız anlık bildirimleri desteklemiyor.',
  PUSH_TOKEN_FAILED: 'Bildirim onayı alamadık. Lütfen bildirim izinlerini kontrol edip tekrar deneyin.',
  PUSH_ACTIVE: 'Harika! Artık gruptaki tüm gelişmelerden anında haberdar olacaksın.',
  DEVICE_REG_SUCCESS: 'Bu cihaz başarıyla kaydedildi.',
  PUSH_CANCELLED: 'Bildirim iznini reddeddin. Daha sonra site ayarlarından aktif edebilirsin.',
  PERM_DENIED_DESC: 'Lütfen cihaz ayarlarından uygulamanın bildirimlerine izin verin.',
  PERM_NOT_APPROVED: 'Bildirim izni onaylanmadı.',
  PUSH_REFRESHED: 'Bildirim bağlantın başarıyla yenilendi.',
  INVITE_SHUTDOWN: 'Davetiyeler kapatıldı. Biraz heyecan katalım, kura çekilişi zamanlandı!',
  INVITES_CLOSED: 'Davetiyeler kapatıldı. Kura çekilişi 5 dakika sonrasına zamanlandı!',
  GROUP_DELETED: 'Grup ve gruba bağlı tüm detaylar sistemden tamamen kaldırıldı.',
  GROUP_CANCELLED_SUCCESS: 'Grup ve tüm davetiyeleri iptal edildi.',
  GROUP_LEFT: 'Bu gruptan başarıyla ayrıldın.',
  LEFT_GROUP_SUCCESS: 'Gruptan başarıyla ayrıldınız.',
  MIN_MEMBERS_REQUIRED: 'En az 3 katılımcı gerekli. Daha fazla kişi davet et veya grubu sil.',
  ORDER_SAVED: 'Yeni sıralama sisteme kaydedildi ve kilitlendi.',
  CARD_DOWNLOAD_SUCCESS: 'Davetiye kartı cihazına indirildi. Hemen paylaşabilirsin ⬇️',
  CARD_DOWNLOADING: 'Davetiye kartı cihaza indiriliyor ⬇️',
  CARD_DOWNLOAD_ERROR: 'Davetiye kartını indirirken beklenmedik bir sorun oluştu.',
  LINK_COPIED: 'Davet linki panoya kopyalandı.',
  INVITE_SENT_SUCCESS: (name: string) => `${name} kişisine bildirim gönderildi.`,
  INVITE_FAILED_DESC: (err: string) => err || 'Bir hata oluştu',
  FETCH_NOTIFS_ERROR: 'Bildirim listesi güncellenemedi. Lütfen internet bağlantınızı kontrol edin.',
  NOTIF_ENABLE_FAILED: (err: string) => `Bildirimler etkinleştirilemedi: ${err}`,
  NOTIF_RETRY_FAILED: 'Lütfen bildirim izinlerini kontrol edip tekrar deneyin.'
}
